import { COLOR_PALETTE } from 'constants/ui';
import { getConditionalObject } from 'utils/data';

export const labelRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  minHeight: '24px',
};

export const getCustomBoxStyles = disabled => ({
  marginBottom: '24px',
  position: 'relative',
  width: '100%',
  ...getConditionalObject(disabled, {
    pointerEvents: 'none',
    opacity: 0.5,
  }),
});

export const errorTooltipStyles = {
  padding: '10px',
  maxWidth: '600px',
  fontSize: '12px',
  fontWeight: 'normal',
  color: COLOR_PALETTE.GRAY[1],
  backgroundColor: COLOR_PALETTE.GRAY[9],
  borderRadius: '8px',
};

export const roleBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '8px',
  padding: '2px 8px',
  backgroundColor: ({ palette }) => palette.background.default,
};

export const modeSwitchStyles = {
  display: 'inline-flex',
  gap: '4px',
  marginLeft: 'auto',
};
